import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Select from "react-select";
import "./TransactionModal.css";

const style = {
  position: "absolute",
  top: "37%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "400px",
  bgcolor: "#fff",
  border: 0,
  outline: "none",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  minHeight: "52vh",
};

const TransactionModal = (props) => {
  const {
    modalStatus,
    setModalStatus,
    transactions,
    setTransactions,
    singleTransaction,
    setSingleTransaction,
    myIndex,
    addOrUpdateTransactions,
    mCurrencySettings,
    FormatPriceNumeral,
    FormatPriceVerbal,
  } = props;

  const [amount, setAmount] = useState();

  const [paymentType, setPaymentType] = useState("cash");

  const [Tcomment, setTcomment] = useState("");

  const [error, setError] = useState("");

  //this side effect is used to add values when the modal in opened in update state
  useEffect(() => {
    if (modalStatus === "update") {
      const initialValues = {
        amount: singleTransaction !== null ? singleTransaction.amount : 0,
        paymentType:
          singleTransaction !== null ? singleTransaction.paymentType : "cash",
        comment: singleTransaction !== null ? singleTransaction.comment : "",
      };
      setAmount(initialValues.amount);
      setPaymentType(initialValues.paymentType);
      setTcomment(initialValues.comment);
    }
    return () => {
      setError("");
    };
  }, [singleTransaction, modalStatus]);

  const handleClose = () => {
    setAmount();
    setPaymentType("cash");
    setTcomment("");
    setModalStatus("");
    setSingleTransaction(null);
  };
  const handleSubmitForm = async () => {
    if (amount === 0 || amount === "" || !amount) {
      setError("enter amount of the transaction");
      return;
    }
    let temp = transactions;
    if (myIndex !== -1) {
      if (transactions[myIndex].hasOwnProperty("id")) {
        const id = transactions[myIndex].id;
        temp[myIndex] = {
          amount,
          paymentType,
          comment: Tcomment,
          added: singleTransaction.added,
          id: id,
        };
      }
      setTransactions(temp);
    } else {
      temp.push({ amount, paymentType, comment: Tcomment, added: new Date() });
      setTransactions(temp);
    }
    handleClose();
    await setTimeout(1000);
    addOrUpdateTransactions();
  };
  return (
    <Modal
      open={modalStatus === "" ? false : true}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="Custom-Modal-Box" sx={style}>
        <form className="Transaction-model">
          <div className="Transaction-model-header">
            <p className="modal-heading">Transaction</p>
            <div className="modal-close-icon" onClick={handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                class="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </div>
          <hr className="mb-4" />

          <div className="transaction-inputs">
            <div className="amount-input">
              <label className="modal-form-field-label" htmlFor="number">
                Amount {amount && " " + mCurrencySettings?.currency}
                &nbsp;
                {mCurrencySettings.currencyFormat === "numeral"
                  ? FormatPriceNumeral(amount)
                  : FormatPriceVerbal(amount)}
              </label>
              <input
                value={amount}
                // defaultValue={amount}
                // defaultValue={
                //   singleTransaction.amount ? singleTransaction.amount : ""
                // }
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;

                  // if value is not blank, then test the regex

                  if (e.target.value == "" || re.test(e.target.value)) {
                    if (e.target.value < 22222222222222222)
                      setAmount(e.target.value);
                  }
                }}
                className="form-input-field form-control"
                type="number"
                maxLength={"12"}
                min={0}
                pattern="[1-9]"
              />
            </div>
            <div className="pay-type-input">
              <label className="modal-form-field-label" htmlFor="text">
                Pay Type
              </label>
              <Select
                options={[
                  { value: "cash", label: "cash" },
                  { value: "cheque", label: "cheque" },
                  { value: "online-transaction", label: "online-transaction" },
                ]}
                // value={paymentType}
                defaultValue={{ value: "cash", label: "cash" }}
                onChange={(e) => {
                  setPaymentType(e.value);
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    border: "0px",
                    background: "var(--theme-color-light)",
                    outline: "none",
                    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
                  }),
                }}
              />
              {/* <input className="input-style" type="country" /> */}
              {/* <CustomSelect
                options={["cash", "cheque", "online-transaction"]}
                onChange={(e) => {
                  setPaymentType(e.target.value);
                }}
              /> */}
              {/* <select
                className="form-input-field form-select"
                value={paymentType}
                // defaultValue={
                //   singleTransaction.paymentType
                //     ? singleTransaction.paymentType
                //     : "cash"
                // }
                onChange={(e) => {
                  setPaymentType(e.target.value);
                }}
              >
                <option value={"cash"}>Cash</option>
                <option value={"cheque"}>Cheque</option>
                <option value={"online-transaction"}>Online Transaction</option>
              </select> */}
            </div>
          </div>

          <div className="interest-comments">
            <label className="modal-form-field-label" htmlFor="comments">
              Comments
            </label>
            <textarea
              // id="comments"
              name="comments"
              value={Tcomment}
              // defaultValue={
              //   singleTransaction.comment ? singleTransaction.comment : "cash"
              // }
              className="form-input-field"
              onChange={(e) => {
                setTcomment(e.target.value);
              }}
              rows="10"
              cols="39"
            />
          </div>
          <div className="transaction-modal-error">{error}</div>
        </form>

        <Box className="add-deal-btn-container mt-2">
          <button className="close-modal-btn" onClick={handleClose}>
            Cancel
          </button>
          <button className="form-submit-button" onClick={handleSubmitForm}>
            Save
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TransactionModal;
